import { QUERY_KEYS } from 'api/query-keys';
import { useQuery } from 'react-query';
import { EmploymentType } from '@types';
import { useSiteDetection } from 'shared/hooks';
import { sharedWorkersService } from 'api/services';

export const useGetWorkerList = (search: string, employmentTypes?: EmploymentType[]) => {
  const { site } = useSiteDetection();

  const queryFn = async () =>
    await sharedWorkersService.getWorkerList(search, site, employmentTypes);
  return useQuery(QUERY_KEYS.workerList(search), queryFn, { enabled: search.length > 2 });
};
